module.exports = __webpack_public_path__ + "static/media/Brinda.c963b700.png";